export default {
  inputData: {},
  year: null,
  isNavOpen: false,
  loadingScreen: true
};
